<template>
  <v-btn :loading="loading" :color="buttonColor" @click="update" outline>
    <span v-if="success && !error">Обновлено</span>
    <span v-else-if="error && !success">Произошла ошибка</span>
    <span v-else>Обновить скриншоты</span>
    <template v-slot:loader>
      <span>Обновляем...</span>
    </template>
  </v-btn>
</template>

<script>
import { updatePLayableScreenshots } from '../api/playable'

export default {
  props: {
    playableId: {
      type: [String, Number]
    }
  },
  data () {
    return {
      loading: false,
      error: false,
      success: false,
    }
  },
  computed: {
    buttonColor() {
      if (this.success) {
        return 'success'
      }
      if (this.error) {
        return 'error'
      }
      if (this.loading) {
        return 'gray'
      }
      return 'primary'
    },
  },
  methods: {
    update () {
      this.loading = true

      updatePLayableScreenshots(this.playableId)
        .then(() => {
          this.success = true
        })
        .catch(() => {
          this.error = true
        })
        .finally(() => {
          this.loading = false
          setTimeout(() => {
            this.success = false
            this.error = false
          }, 5000)
        })
    },
  }
}
</script>

<style scoped>

</style>
